import { routeTree } from "@/routeTree.gen";
import { createRouter } from "@tanstack/react-router";

export const router = createRouter({
  routeTree,
  defaultPreloadStaleTime: 0,
  context: {
    auth: undefined!,
    apiClient: undefined!,
  },
  defaultPendingMinMs: 0,
  defaultPendingMs: 0,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
